<template lang="pug">
  .modal(
    :class="[...classes, `modal__${type}`, { 'modal_active': active }]"
    v-tap="hide"
  )
    .modal__body
      .modal__close
      template(v-if="type !== 'product'")
        .modal__wrap(:style="wrapStyle")
          slot
      template(v-else)
        slot
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  props: {
    classes: {
      type: Array,
      default: () => ([])
    },
    type: {
      type: String,
      required: true
    },
    wrapStyle: {
      type: Object,
      default: () => ({})
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    active (value) {
      if (value) {
        disableBodyScroll(this.$el)
      } else {
        enableBodyScroll(this.$el)
      }
    }
  },
  methods: {
    hide (event) {
      if (
        event.target.classList.contains('modal') ||
        event.target.classList.contains('modal__close')
      ) {
        this.$emit('hide')
      }
    }
  }
}
</script>
